<template>
  <b-modal id="raiseIssueModal" v-model="modalVisible" centered hide-footer no-close-on-backdrop hide-header-close
    modal-class="planswitchhistory-modal">
    <template #modal-header>
      <div class="view-clients-header">
        <b-button variant="close-btn" class="btn-container" @click="closeModal">
          <i class="fas fa-times"></i>
        </b-button>
      </div>
    </template>
    <div class="planswitchhistory_modal--card">
      <div class="modal-header-wrapper">
        <div class="icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
              <path d="M14.186 2.753v3.596c0 .487.195.955.54 1.3a1.85 1.85 0 0 0 1.306.539h4.125" />
              <path
                d="M20.25 8.568v8.568a4.25 4.25 0 0 1-1.362 2.97a4.28 4.28 0 0 1-3.072 1.14h-7.59a4.3 4.3 0 0 1-3.1-1.124a4.26 4.26 0 0 1-1.376-2.986V6.862a4.25 4.25 0 0 1 1.362-2.97a4.28 4.28 0 0 1 3.072-1.14h5.714a3.5 3.5 0 0 1 2.361.905l2.96 2.722a2.97 2.97 0 0 1 1.031 2.189M7.647 7.647h3.265M7.647 12h8.706m-8.706 4.353h8.706" />
            </g>
          </svg>
        </div>
        <div class="content-wrap">
          <div class="title-wrap">
            Plan Switch
          </div>
          <div class="content-date">
            {{ formatDate(row.created_at) }}
          </div>
        </div>
      </div>
      <div class="plan-switch-wrapper">
        <div class="row align-items-center">
          <div class="col-5">
            <div class="old-plan plan-content">
              <div class="title">
                From
              </div>
              <div class="plan-name">
                {{ row.old_plan_name }}
              </div>
            </div>
          </div>
          <div class="col-2">
            <div class="arrow-icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 640 640">
                <path fill="currentColor"
                  d="M439.1 297.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L371.2 320L233.9 182.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z" />
              </svg>
            </div>
          </div>
          <div class="col-5">
            <div class="new-plan plan-content">
              <div class="title">
                To
              </div>
              <div class="plan-name">
                {{ row.new_plan_name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul class="planswitch-contentlistwrapper">
        <li>
          <div class="left-content">System ID</div>
          <div class="right-content">{{ row.policy_id }}</div>
        </li>
        <li>
          <div class="left-content">Member Name</div>
          <div class="right-content">{{ row.member_name }}</div>
        </li>
        <li>
          <div class="left-content">Requested From</div>
          <div class="right-content">{{ row.origin }}</div>
        </li>
        <li>
          <div class="left-content">Performed by</div>
          <div class="right-content">{{ row.requested_by }}</div>
        </li>
      </ul>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
    row: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      modalVisible: this.isOpen,
    };
  },

  watch: {
    isOpen(val) {
      this.modalVisible = val;
    },
    modalVisible(val) {
      if (!val) this.$emit("close");
    },
  },

  methods: {
    formatDate(isoString) {
      if (!isoString) return '';
      return new Date(isoString).toLocaleString('en-US', {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      });
    },

    closeModal() {
      this.modalVisible = false;
    },
  },
};
</script>

<style>
.planswitchhistory-modal .modal-header {
  padding: 6px 10px;
}
</style>
<style scoped>
.planswitchhistory_modal--card {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.planswitchhistory_modal--card .modal-header-wrapper {
  display: flex;
  gap: 14px;
}

.planswitchhistory_modal--card .modal-header-wrapper .icon-wrapper {
  background-color: rgba(0, 204, 255, 0.1);
  color: #00CCFF;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  flex-shrink: 0;
}

.planswitchhistory_modal--card .modal-header-wrapper .icon-wrapper svg {
  width: 24px;
  height: 24px;
}

.planswitchhistory_modal--card .modal-header-wrapper .content-wrap .title-wrap {
  font-weight: 600;
}

.planswitchhistory_modal--card .modal-header-wrapper .content-wrap .content-date {
  color: #8E8E8E;
  font-size: 13px;
}

.planswitchhistory_modal--card .plan-switch-wrapper {
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  background: #F3F4F6;
  padding: 14px;
}

.planswitchhistory_modal--card .plan-switch-wrapper .plan-content .title {
  color: #717171;
  font-size: 12px;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.planswitchhistory_modal--card .plan-switch-wrapper .plan-content .plan-name {
  font-size: 14px;
  color: #323C47;
  text-transform: uppercase;
  font-weight: 500;
}

.planswitchhistory_modal--card .plan-switch-wrapper .arrow-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #606060;
}

.planswitchhistory_modal--card .plan-switch-wrapper .arrow-icon-wrap svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.planswitchhistory_modal--card .planswitch-contentlistwrapper {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.planswitchhistory_modal--card .planswitch-contentlistwrapper li {
  display: flex;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #D7E1EA;
  gap: 20px;
}

.planswitchhistory_modal--card .planswitch-contentlistwrapper li:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.planswitchhistory_modal--card .planswitch-contentlistwrapper li .left-content {
  color: #7E7E7E;
}
</style>